export default __webpack_public_path__ + "static/media/case-ih-mx-135.41d0e4e8.jpg";